export const clearFilter = (filter, keys) => {
    const { sections } = filter;
    const hasValidFilterKeys = keys.every(key => key in sections);
    if (!hasValidFilterKeys) {
        throw new Error(`Invalid filter keys for ${filter.type} filter.`);
    }
    keys.forEach(key => {
        sections[key].options.forEach(option => {
            option.selected = false;
        });
    });
};
